import { useContext, useEffect, useMemo, useState } from "react";
// import "../styles/bestseller.css"; // 🔥 SAME CSS AS BESTSELLER
import "../styles/shopbyspares.css";
import { shopbySpares } from "../services/Spares";
import noimage from "../assets/noimage.webp";
import cart from "../assets/cart.png";
import wishlist from "../assets/wishlist.png";
import { CartContext } from "../contextApi/CartContext";
import Banner from "../assets/image1.png";
import { Notifyed } from "../services/Auth";

import {
  AddItemToWishList,
  AddItemToCart,
  DeleteFromWishList,
  getProductQty,
} from "../services/Cart";
import { FaRegHeart, FaHeart } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Spin } from "antd";
import { FaArrowDown } from "react-icons/fa6";
import { showSnackbar } from "../comopnents/snackbar";
import AuthModal from "../comopnents/AuthModal";
import CartQuantityControl from "../comopnents/CartQuantityControl";
import PurchaseOptionsModal from "../comopnents/PurchaseOptionsModal";
import {
  buildCartPurchaseData,
  buildEnhancedPurchaseData,
  getMinimumPurchaseQuantity,
  getMinOrderQty,
  getPurchaseQuantityStep,
  getSavedCartPurchaseData,
  shouldShowPurchaseModal,
} from "../utils/purchaseOptions";
import { isOutOfStock } from "../utils/stock";

function ShopbySpares() {
  const isLoggedIn = Boolean(localStorage.getItem("token"));
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [products, setProducts] = useState([]);
  const [wishlistItems, setWishlistItems] = useState([]);
  const [wishlistedProducts, setWishlistedProducts] = useState({});
  const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [pendingCartId, setPendingCartId] = useState(null);
  const [showPurchaseModal, setShowPurchaseModal] = useState(false);
  const [pendingPurchaseProduct, setPendingPurchaseProduct] = useState(null);
  const [maxPrice, setMaxPrice] = useState(0);
  const [priceLimit, setPriceLimit] = useState(0);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [selectedModels, setSelectedModels] = useState([]);
  const [minDiscount, setMinDiscount] = useState(0)
  const [filteredMaxPrice, setFilteredMaxPrice] = useState(0);

  const {
    addToCart,
    deleteCartItems,
    itemList,
    updateQty,
    setCartQty,
    userId,
    removeFromCart,
  } = useContext(CartContext);
  const [wishlist, setWishlist] = useState({});

  const navigate = useNavigate();

  const goToProductDetail = (productId) => {
    navigate(`/productdetail?productid=${productId}`);
  };

  const openPurchaseModal = (product) => {
    const userId = localStorage.getItem("userId");
    if (!userId) {
      setPendingCartId({ product });
      setShowAuthModal(true);
      return;
    }

    if (!shouldShowPurchaseModal(product)) {
      const purchaseData = buildCartPurchaseData(product, "piece");
      handleAddToCart(product, purchaseData.quantity, purchaseData);
      return;
    }
    setPendingPurchaseProduct(product);
    setShowPurchaseModal(true);
  };

  const confirmPurchaseType = async (purchaseType, couponData) => {
    if (!pendingPurchaseProduct) return;
    const purchaseData = buildEnhancedPurchaseData(pendingPurchaseProduct, purchaseType, couponData);
    await handleAddToCart(pendingPurchaseProduct, purchaseData.quantity, purchaseData);
    setShowPurchaseModal(false);
    setPendingPurchaseProduct(null);
  };

  const handleAddToCart = async (product, qty, purchaseData = null) => {
    const productId = product?.productid || product;
    if (isOutOfStock(product)) {
      await handleNotifyMe(productId);
      return;
    }

    const userId = localStorage.getItem("userId");

    if (!userId) {
      setPendingCartId({ product, productId, qty, purchaseData });
      setShowAuthModal(true);
      return;
    }

    try {
      const payload = { customerid: userId, productid: productId, qty: qty, stock: product?.stock };
      await AddItemToCart(payload);
      addToCart(productId, qty, purchaseData);
      showSnackbar("success", "Item added to cart!");
    } catch (error) {
      console.error(
        "Add to cart error:",
        error.response?.data || error.message,
      );
      showSnackbar("error", "Failed to add item to cart!");
    }
  };

  const handleAuthSuccess = () => {
    setShowAuthModal(false);
    if (pendingCartId) {
      handleAddToCart(pendingCartId.product || pendingCartId.productId, pendingCartId.qty, pendingCartId.purchaseData);
      setPendingCartId(null);
    }
  };

  const handleCartQtyChange = async (productId, newQty) => {
    const userId = localStorage.getItem("userId");
    if (!userId) {
      setPendingCartId({ productId, qty: newQty });
      setShowAuthModal(true);
      return;
    }

    try {
      await getProductQty({ user_id: userId, productid: productId, qty: newQty });
      setCartQty(productId, newQty);
    } catch (error) {
      console.error("API Error:", error?.message || error);
      showSnackbar("error", "Failed to update quantity");
    }
  };

  /* ================= FETCH DATA ================= */
  const shopbySparesRes = async () => {
    try {
      setLoading(true);
      const data = await shopbySpares();
      const uniqueProducts = Array.from(
        new Map(data?.data.map((item) => [item.productid, item])).values(),
      );

      setProducts(uniqueProducts);

      const highestPrice = uniqueProducts.length
        ? Math.max(...uniqueProducts.map((p) => p.mrp || 0))
        : 0;
      setPriceLimit(highestPrice);
      setMaxPrice(highestPrice);
      // setProducts(response.data || []);
      // console.log("Shop by spares:", response);
      setLoading(false);
    } catch (error) {
      console.error("Shop API error:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    shopbySparesRes();
  }, []);

  const uniqueBrands = useMemo(() => {
    let result = [...products];

    if (selectedCategory) {
      result = result.filter((p) => p.category === selectedCategory);
    }

    if (selectedModels.length) {
      result = result.filter((p) =>
        selectedModels.includes(p.modelno || p.displaymodelno),
      );
    }

    return [...new Set(result.map((p) => p.brand).filter(Boolean))];
  }, [products, selectedCategory, selectedModels]);



  // ----- Calculate Categories & Models -----
  const categories = useMemo(() => {
    const map = {};
    products.forEach((p) => {
      if (!map[p.category]) map[p.category] = 0;
      map[p.category]++;
    });
    return Object.keys(map).map((k) => ({ name: k, count: map[k] }));
  }, [products]);

  const models = useMemo(() => {
    const map = {};
    products.forEach((p) => {
      const model = p.modelno || p.displaymodelno;
      if (!map[model]) map[model] = 0;
      map[model]++;
    });
    return Object.keys(map).map((k) => ({ name: k, count: map[k] }));
  }, [products]);


  // ----- Filter Products -----
  useEffect(() => {
    let result = [...products];

    if (selectedCategory) {
      result = result.filter((p) => p.category === selectedCategory);
    }

    if (selectedModels.length) {
      result = result.filter((p) =>
        selectedModels.includes(p.modelno || p.displaymodelno),
      );
    }
    if (minDiscount > 0) {
      result = result.filter((p) => (p.discount || 0) >= minDiscount);
    }
    // ✅ Brand filter (NEW)
    if (selectedBrands.length) {
      result = result.filter((p) => selectedBrands.includes(p.brand));
    }

    result = result.filter((p) => {
      let price = p.mrp;
      if (p.discount) price = price - (price * p.discount) / 100;
      return price <= maxPrice;
    });

    setFilteredProducts(result);

    const filteredMax = result.length
      ? Math.max(
        ...result.map((p) => {
          let price = p.mrp;
          if (p.discount) price = price - (p.discount * price) / 100;
          return price;
        }),
      )
      : 0;
    setFilteredMaxPrice(filteredMax);
  }, [products, selectedCategory, selectedModels, maxPrice, selectedBrands, minDiscount]);

  // ----- Display Max Price -----
  const displayMaxPrice = useMemo(() => {
    if (!filteredProducts.length) return 0;
    return Math.max(
      ...filteredProducts.map((p) => {
        let price = p.mrp;
        if (p.discount) price = price - (p.discount * price) / 100;
        return price;
      }),
    );
  }, [filteredProducts]);


  const calculateFilteredPriceLimit = () => {
    let filteredProducts = [...products];

    if (selectedCategory) {
      filteredProducts = filteredProducts.filter(
        (p) => p.category === selectedCategory
      );
    }

    if (selectedModels.length) {
      filteredProducts = filteredProducts.filter((p) =>
        selectedModels.includes(p.modelno || p.displaymodelno)
      );
    }

    if (!filteredProducts.length) return 0;

    return Math.max(
      ...filteredProducts.map((p) => {
        const mrp = Number(p.mrp || 0);
        const discount = Number(p.discount || 0);

        return mrp - (mrp * discount) / 100;
      })
    );
  };

  // Update price limit based on category/model selection
  useEffect(() => {
    const newPriceLimit = calculateFilteredPriceLimit();
    setPriceLimit(newPriceLimit);
    setMaxPrice(newPriceLimit);
  }, [products, selectedCategory, selectedModels]);

  // Reset slider when category changes
  useEffect(() => {
    if (selectedCategory) {
      const categoryMax = calculateFilteredPriceLimit();
      if (categoryMax > 0) {
        setMaxPrice(categoryMax);
      }
    }
  }, [selectedCategory]);

  // ----- Handle Cart -----
  // const handleAddToCart = async (id, qty) => {
  //   try {
  //     const userId = localStorage.getItem("userId");
  //     if (!userId) {
  //       setPendingCartId({ id, qty });
  //       setShowAuthModal(true);
  //       return;
  //     }

  //     await AddItemToCart({ customerid: userId, productid: id, qty });
  //     addToCart(id, qty);
  //     showSnackbar("success", "Item Added to Cart!");
  //   } catch (error) {
  //     console.error("Add to cart error:", error);
  //   }
  // };

  // const handleAuthSuccess = () => {
  //   setShowAuthModal(false);
  //   if (pendingCartId) {
  //     handleAddToCart(pendingCartId.id, pendingCartId.qty);
  //     setPendingCartId(null);
  //   }
  // };

  // ----- Wishlist -----
  const AddToWishListHandler = async (productid) => {
    try {
      const userId = localStorage.getItem("userId");
      if (!userId) {
        setPendingCartId(productid);
        setShowAuthModal(true);
        return;
      }

      if (wishlistItems.includes(productid)) return;

      await AddItemToWishList({ customerid: userId, productid });
      showSnackbar("success", "Item Added to Wishlist!");
      setWishlistItems((prev) => [...prev, productid]);
    } catch (error) {
      console.error("Wishlist error:", error);
    }
  };

  const handleDeleteWishList = async (productid) => {
    try {
      const userId = localStorage.getItem("userId");
      if (!userId) return;

      await DeleteFromWishList({ customerid: userId, productid });
      setWishlist((prev) => ({ ...prev, [productid]: false }));
    } catch (err) {
      console.error("Error deleting from wishlist:", err);
    }
  };

  const handleNotifyMe = async (productid) => {
    const userId = localStorage.getItem("userId");
    if (!userId) {
      setPendingCartId(productid);
      setShowAuthModal(true);
      return;
    }
    try {
      await Notifyed({ customerid: userId, productid });
      showSnackbar("success", "We will notify you when product is available");
    } catch (err) {
      console.error(err);
      showSnackbar("error", "Failed to register notify request");
    }
  };

  // ----- Toggle Models -----
  const toggleModel = (model) => {
    setSelectedModels((prev) =>
      prev.includes(model) ? prev.filter((m) => m !== model) : [...prev, model],
    );
  };

  return (
    <div style={styles.container}>
      <div className="shop-container">
        {/* ================= FILTERS ================= */}

        <div className="filters">
          <h3>Product Categories</h3>

          <ul className="category-list">
            {categories.map((c, i) => (
              <li
                key={i}
                className={selectedCategory === c.name ? "active" : ""}
                onClick={() => setSelectedCategory(c.name)}
              >
                <span>{c.name}</span>
                <span className="category-count">({c.count})</span>
              </li>
            ))}
          </ul>

          {/* Price Filter */}
          <div className="price-filter">
            <h4>Filter By Price</h4>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "14px",
                marginBottom: "8px",
                fontWeight: "500",
              }}
            >
              <span>₹0</span>
              <span>Upto ₹{priceLimit > 0 ? priceLimit?.toFixed(0) : "0"}</span>
            </div>

            <input
              type="range"
              className="price-slider"
              min="0"
              max={priceLimit > 0 ? priceLimit : 0}
              step="10"
              value={maxPrice}
              onChange={(e) => setMaxPrice(Number(e.target.value))}
              style={{
                width: "100%",
                cursor: "pointer",
              }}
            />

            <div
              style={{
                textAlign: "center",
                marginTop: "10px",
                padding: "8px",
                background: "#f5f5f5",
                borderRadius: "6px",
                fontWeight: "600",
                color: "#005487",
              }}
            >
              Price Range: ₹0 - ₹{maxPrice > 0 ? maxPrice?.toFixed(0) : priceLimit?.toFixed(0)}
            </div>
          </div>

          {/* Brand Filter */}
          <div className="brand-filter" style={{ marginTop: "20px" }}>
            <h4>Filter By Brand</h4>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
              }}
            >
              {uniqueBrands?.map((brand) => (
                <label
                  key={brand}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  <input
                    style={{ marginRight: 10 }}
                    type="checkbox"
                    checked={selectedBrands.includes(brand)}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedBrands((prev) => [...prev, brand]);
                      } else {
                        setSelectedBrands((prev) =>
                          prev.filter((b) => b !== brand)
                        );
                      }
                    }}
                  />
                  {brand}
                </label>
              ))}
            </div>
          </div>

          {/* Discount Filter */}
          <div className="discount-filter" style={{ marginTop: "20px" }}>
            <h4>Filter By Discount</h4>

            <div
              style={{
                textAlign: "center",
                marginBottom: "8px",
                fontWeight: "500",
              }}
            >
              {minDiscount}% and above
            </div>

            <input
              type="range"
              className="discount-slider"
              min="0"
              max="80"
              step="5"
              value={minDiscount}
              onChange={(e) => setMinDiscount(Number(e.target.value))}
              style={{
                width: "100%",
                cursor: "pointer",
              }}
            />
          </div>

          {/* Clear Filters */}
          <button
            className="clear-filters"
            style={{
              marginTop: "20px",
              width: "100%",
            }}
            onClick={() => {
              setSelectedCategory(null);
              setSelectedModels([]);
              setSelectedBrands([]);
              setMinDiscount(0);
              setMaxPrice(priceLimit);
            }}
          >
            Clear All Filters
          </button>
        </div>

        <section className="product-content">
          <div className="shopproductgridd">
            {loading ? (
              <Spin tip="Loading" size="large">
                {/* Loading... */}
              </Spin>
            ) : (
              filteredProducts.map((product) => {
                const qty =
                  itemList.find(
                    (item) => String(item.productId) === String(product.productid),
                  )?.count || 0;
                const minorderqty = product.minorderqty || product.dtl?.[0]?.minorderqty || 1;
                const stock = product.stock || product.dtl?.[0]?.stock || 0;
                const savedPurchaseData = getSavedCartPurchaseData(product.productid);
                const purchaseType = savedPurchaseData?.purchaseType || "piece";

                return (
                  <div className="bestsellers-cardd" key={product.productid}>
                    {/* ACTION ICONS */}
                    <div className="bestsellers-actions">
                      <button
                        onClick={() => {
                          setWishlist((prev) => {
                            const updated = !prev[product.productid];
                            updated
                              ? AddToWishList(product.productid)
                              : handleDeleteWishList(product.productid);

                            return { ...prev, [product.productid]: updated };
                          });
                        }}
                      >
                        {wishlist[product.productid] ? (
                          <FaHeart color="red" />
                        ) : (
                          <FaRegHeart />
                        )}
                      </button>

                      {/* <button onClick={() => addToCart(product.productid)}>
                  <img src={cart} alt="Cart" />
                </button> */}
                    </div>

                    {/* DISCOUNT */}
                    {isLoggedIn && product.discount > 0 && (
                      <span className="discount-percentege">
                        {product.discount}%
                      </span>
                    )}

                    {/* IMAGE */}
                    <img
                      className="img2"
                      src={
                        product.image1?.trim() ||
                        product.image2?.trim() ||
                        product.image3?.trim() ||
                        noimage
                      }
                      alt={product.description}
                      onError={(e) => (e.target.src = noimage)}
                      onClick={() => goToProductDetail(product.productid)}
                    />

                    {/* INFO */}
                    <div className="product-info">
                      <p className="bestsellers-category">
                        {product.category || product.subcategory || "Spare Parts"}
                      </p>
                      <h4 className="producttitle">
                        {product.brand || "Product Name"}
                      </h4>

                      {/* <h4 className="producttitle">
                    {product.displaymodelno || "Product Name"}
                  </h4> */}
                      <h4 className="producttitle">
                        {product.modelno || "Product Name"}

                        ({product.mainmodelno || "Product Name"})
                      </h4>
                      <h4

                        style={{
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          lineHeight: "20px",
                          maxHeight: "40px",
                          fontSize: "14px",
                          fontWeight: 600,
                          color: "#3d3c3c",
                          marginBottom: "6px",
                          textAlign: "left",
                        }}
                      >
                        {product.description || "Product Name"}
                      </h4>



                      <div style={{ display: "flex", flexDirection: "column-reverse", gap: "5px" }}>
                        {!isLoggedIn && product.mrp && (
                          <div style={{ fontWeight: "bold", color: "#5b5858", fontSize: "16px" }}>
                            MRP: ₹{Number(product.mrp).toFixed(2)}
                          </div>
                        )}
                        {isLoggedIn && (
                        <>
                        {product.mrp && Number(product.netrate || product.dtl?.[0]?.netrate || 0) <= 0 && (
                          <div style={{ color: "#888" }}>
                            <FaArrowDown color="black" />

                            <span style={{ textDecoration: "line-through" }}>
                              MRP: ₹{Number(product.mrp).toFixed(2)}
                            </span>
                          </div>
                        )}

                        {Number(product.netrate || product.dtl?.[0]?.netrate || 0) > 0 ? (
                          <div
                            style={{
                              fontWeight: "bold",
                              color: "#5b5858",
                              fontSize: "16px",
                            }}
                          >
                            Rs. {Number(product.netrate || product.dtl?.[0]?.netrate).toFixed(2)}
                          </div>
                        ) : product.mrp && product.discount > 0 && (
                          <div
                            style={{
                              fontWeight: "bold",
                              color: "#5b5858",
                              fontSize: "16px",
                            }}
                          >
                            ₹
                            {Math.round(
                              product.mrp - (product.mrp * product.discount) / 100,
                            ).toFixed(2)}
                          </div>
                        )}
                          </>
                        )}
                      </div>

                      {stock <= 0 ? (
                        <button
                          style={{
                            width: "100%",
                            padding: "7px",
                            borderRadius: "25px",
                            border: "none",
                            fontWeight: "600",
                            backgroundColor: "#e0e0e0",
                            color: "#777777",
                            transition: "background-color 0.3s ease",
                          }}
                          onClick={() => handleNotifyMe(product.productid)}
                        >
                          Notify Me
                        </button>
                      ) : qty > 0 ? (
                        <CartQuantityControl
                          qty={qty}
                          minQty={getMinimumPurchaseQuantity(product, purchaseType)}
                          step={purchaseType !== "piece" ? getPurchaseQuantityStep(product, purchaseType) : undefined}
                          stock={stock}
                          purchaseType={purchaseType}
                          product={product}
                          onChange={(newQty) =>
                            handleCartQtyChange(product.productid, newQty)
                          }
                          className="qty-box"
                        />
                      ) : (
                        <button
                          style={{
                            width: "100%",
                            padding: "7px",
                            borderRadius: "25px",
                            border: "none",
                            fontWeight: "600",
                            backgroundColor: "#005487",
                            color: "#ffffff",
                            transition: "background-color 0.3s ease",
                          }}
                          onClick={() =>
                            openPurchaseModal(product)
                          }
                        >
                          Add to Cart
                        </button>
                      )}
                    </div>
                  </div>
                );
              })
            )}

            {filteredProducts.length === 0 && (
              <div className="no-products">
                <p>No products found</p>
              </div>
            )}

            {showAuthModal && (
              <AuthModal
                initialMode="login"
                onClose={() => setShowAuthModal(false)}
                onSuccess={handleAuthSuccess}
              />
            )}

            <PurchaseOptionsModal
              isOpen={showPurchaseModal}
              product={pendingPurchaseProduct}
              onClose={() => {
                setShowPurchaseModal(false);
                setPendingPurchaseProduct(null);
              }}
              onConfirm={confirmPurchaseType}
            />
          </div>
        </section>
      </div >
    </div >
  );
}
const styles = {
  container: {
    background: "white",
    padding: "20px",
    borderRadius: "8px",
    color: 'black'
  }
};
export default ShopbySpares;
